import { PapiDeviation } from '@wix/da-papi-types';
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { ResourceType } from '../../../types/resource';

import s from './CommissionCover.scss';

const getCoverImageAttributes = (
  deviation: PapiDeviation
): React.CSSProperties => {
  const coverUrl = DeviationMediaService.getLargestFullview(deviation).src;

  return {
    backgroundImage: `url('${coverUrl}')`,
  };
};

export interface Props {
  deviation: PapiDeviation;
}

export const CommissionCover: React.FC<Props> = ({ deviation }) => {
  const isMobile = useContext(MobileContext);

  if (isMobile || !deviation.coverImage) {
    return null;
  }

  const coverImageStyle = getCoverImageAttributes(deviation.coverImage);

  return (
    <div
      className={s['cover-image']}
      data-itemid={deviation.coverImage.deviationId}
      data-typeid={ResourceType.DEVIATION}
      style={coverImageStyle}
    ></div>
  );
};
CommissionCover.displayName = 'CommissionCover';

export default CommissionCover;
